// 默认保留的分页高度
const DEAULT_PAGINATION_HEIGHT = 58

export function getTable2Props(table2Wrap) {
  const { tableConfig } = table2Wrap.$props
  const { option = {} } = tableConfig
  const {
    type,
    showIndex = true,
    selectable,
    highlightCurrentRow,
    showOverflowTooltip,
    spanMethod,
    rowHeight,
    enableDynamicHeight,
    enableExpandRow,
    reserveHeight,
    showEmpty = false,
    rowCellCanSelected,
    emptyText,
    // footerRows,
    cellStyle,
    headerCellStyle,
    headerRowClassName,
    // fixedRowsTop,
    // fixedRowsData,
    showRadio,
    reserveSelection,
    headerAlign,
    headerHeight,
    autoResetScrollTop = false,
    touchPopoverContent,
    tableMode,
    cacheSize,
    width,
    height,
    border,
    fixedHeader,
    page,
    treeProps,
    // expandedRowKeys = [],
    mergeEqualCellsOption,
    expandColumnKey,
    showOverflowTooltipOnHeader,
    mergeCells,
    mergeCellsScope,
    treeTableLoad,
    useHorizontalVirtualScroll = true,
    popoverEffect,
    popoverOpenDelay,
    scrollbarAlwaysOn = true,
    dynamicHeightResizable = false,
    autoLowHeight = true,
    scrollPreventDefault = false,
    stopWheel = false,
    checkBoxDisableSelect = false,
    isCollapseMoveCheck,
    defaultClickSortOrder = 'ascending'
  } = option
  const showSelection = type === 'selection'
  const props = {
    autoResetScrollTop,
    columns: table2Wrap.formatColumns,
    showSelection,
    showIndex,
    selectable,
    highlightCurrentRow: highlightCurrentRow !== false,
    showOverflowTooltip: showOverflowTooltip !== false,
    spanMethod,
    rowHeight,
    enableDynamicHeight,
    enableExpandRow,
    reserveHeight: page ? (reserveHeight || DEAULT_PAGINATION_HEIGHT) : undefined,
    showEmpty,
    rowCellCanSelected,
    emptyText,
    // footerRows,
    cellStyle,
    headerCellStyle,
    headerRowClassName,
    // fixedRowsTop,
    // fixedRowsData,
    showRadio,
    reserveSelection,
    headerAlign,
    headerHeight,
    touchPopoverContent,
    mode: tableMode,
    cacheSize,
    width,
    height,
    border,
    fixedHeader,
    treeProps,
    // 2024-11-08 由于此处整个props返回是一个新的对象，导致外层依赖更新render时，会触发table2的watch更新,导致对比不一样
    // expandedRowKeys: [...propsExpandedRowKeys, ...expandedRowKeys],
    mergeEqualCellsOption,
    expandColumnKey,
    showOverflowTooltipOnHeader,
    mergeCells,
    mergeCellsScope,
    useHorizontalVirtualScroll,
    popoverEffect,
    popoverOpenDelay,
    scrollbarAlwaysOn,
    dynamicHeightResizable,
    autoLowHeight,
    scrollPreventDefault,
    stopWheel,
    checkBoxDisableSelect,
    isCollapseMoveCheck,
    defaultClickSortOrder
  }
  // 树形异步加载
  if (typeof treeTableLoad === 'function') {
    props.load = treeTableLoad
    props.lazy = true
  }
  return props
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/table2/props.js